import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { setStep, BOOKING_STEP } from '../../actions/Booking';
import { submitPasswordReset } from '../../actions/Session';

import '../../static/less/user_login.less';

class PasswordResetToken extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      password1: '',
      password2: '',
      passwordsMatch: false,
      resetSuccess: false,
      resetResult: '',
    };
    this.passwordReset = this.passwordReset.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(setStep(BOOKING_STEP.NO_AVAIL_STEP));
  }

  updatePassword = (id) => (ev) => {
    const newPass = ev.target.value;
    const otherPass = id === 1 ? this.state.password2 : this.state.password1;
    this.setState({ [`password${id}`]: newPass, passwordsMatch: newPass === otherPass });
  };

  buildRequest() {
    const { params } = this.context.router;
    return {
      user_id: params.uid,
      user_token: params.token,
      password1: this.state.password1,
      password2: this.state.password2,
    };
  }

  passwordReset() {
    this.setState({ resetSuccess: false, resetResult: '' });

    const request = this.buildRequest();
    this.props.dispatch(submitPasswordReset(request)).then(({ success }) => {
      let msg;
      if (success) {
        msg = this.context.t('Your password has been updated');
      } else {
        msg = this.context.t('Your password could not be reset, please try again');
      }
      this.setState({ resetSuccess: success, resetResult: msg });
    });
  }

  render() {
    return (
      <section className="PasswordResetToken container">
        <div className="form-group">
          <div className="col-md-4">
            <label htmlFor="reset-password">{this.context.t('Choose your new password')}:</label>
            <input id="reset-password" className="form-control" type="password" value={this.state.password1}
                   onChange={this.updatePassword(1)} />
          </div>
          <div className="col-md-4">
            <label htmlFor="reset-password2">{this.context.t('Repeat your new password')}:</label>
            <input id="reset-password2" className="form-control" type="password" value={this.state.username}
                   onChange={this.updatePassword(2)} />
          </div>
          <div className="col-md-12">
            <button className="btn btn-primary reset-button" onClick={this.passwordReset}
                    disabled={!this.state.passwordsMatch}>
              {this.context.t('Reset password')}
            </button>
          </div>
          <div className={`col-md-8 reset-result reset-result--${this.state.resetSuccess ? 'success' : 'error'}`}>
            {this.state.resetResult}
          </div>
        </div>
      </section>
    );
  }
}

PasswordResetToken.contextTypes = {
  router: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  user: state.session.user || { isAnonymous: true },
}))(PasswordResetToken);
